import { createSlice } from "@reduxjs/toolkit";
import { Navigate, Route } from "react-router-dom";

const initialState = {
  mode: "light",
  user: null,
  token: null,
  classes: null,
  teacher: [],
  posts: [],
  hod_id: null,
  Hphases: null,
  Hclasses: null,
  subject_id: null,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setMode: (state) => {
      state.mode = state.mode === "light" ? "dark" : "light";
    },
    setLogin: (state, action) => {
      state.user = action.payload.user;
      state.token = action.payload.token;
      localStorage.setItem("authUser", JSON.stringify(action.payload.user));
    },
    setLogout: (state) => {
      state.user = null;
      state.token = null;
      localStorage.removeItem("authUser");
    },
    setFriends: (state, action) => {
      if (state.user) {
        state.user.friends = action.payload.friends;
      } else {
        console.error("user friends non-existent :(");
      }
    },
    setPosts: (state, action) => {
      state.posts = action.payload.posts;
    },
    setPost: (state, action) => {
      const updatedPosts = state.posts.map((post) => {
        if (post._id === action.payload.post._id) return action.payload.post;
        return post;
      });
      state.posts = updatedPosts;
    },
    setBackDropOn: (state, action) => {
      state.back_drop = action.payload.back_drop;
    },
    getBackDropOFF: (state, action) => {
      state.back_drop = action.payload.back_drop;
    },
    setClassCombo: (state, action) => {
      state.class_combo = action.payload;
    },
    setTeacherClass: (state, action) => {
      state.classes = action.payload.classes;
      state.teacher = action.payload.teacher;
    },
    setHistoryData: (state, action) => {
      state.hod_id = action.payload.hod_id;
    },
    setPhaseHistoryData: (state, action) => {
      state.Hphases = action.payload.Hphases;
      state.Hclasses = action.payload.Hclasses;
      state.phase_id = action.payload.phase_id
    },
    setSubjectHistory: (state, action) => {
      state.subject_id = action.payload.subject_id;
    },
    setSubjectIds: (state, action) => {
      state.commonSubjectIds = action.payload.subjectIds;
      state.kgPhase = action.payload.kgPhases;
    },
  },
});

export const {
  setMode,
  setLogin,
  setLogout,
  setFriends,
  setPosts,
  setPost,
  setBackDropOn,
  getBackDropOFF,
  setClassCombo,
  setTeacherClass,
  setSubject,
  setHistoryData,
  setPhaseHistoryData,
  setSubjectHistory,
  setSubjectIds,
} = authSlice.actions;
export default authSlice.reducer;
